import { focus as focusBase } from '#src/app/shared/utils/dom';

export function focus(elt: Element | null | undefined, options?: FocusOptions): boolean {
	return focusBase(elt, { ...options, makeFocusable: true });
}
